import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Typography from '../../../../../../components/Typography';
import { i18nNS } from '../../../../../../i18n';
import AttendanceProgressbar from '../AttendanceProgressbar';
import { StopAttendanceButton } from './styles';
import useAttendanceInProgress from './vm';

const AttendanceInProgress = () => {
  const { t } = useTranslation([i18nNS.GLOSSARY, i18nNS.CLASS]);

  const {
    remainingTime,
    remainingTimePercentage,
    attendanceInProgress,
    markedStudentPercentage,
    handleOnClickStopAttendance,
  } = useAttendanceInProgress();

  if (!attendanceInProgress) return null;

  const { nowMarkedPresent } = attendanceInProgress;

  return (
    <Stack gap={4} height="100%">
      <Stack key="fixed-key" flex={1} alignItems="center" gap={2} py={4.5} px={6.5}>
        <Typography color="warning.400" variant="paragraphMedium">
          {t('time_remaining', { ns: i18nNS.CLASS })}
        </Typography>
        <AttendanceProgressbar
          color="warning"
          value={remainingTimePercentage}
          label={
            <>
              <Typography variant="h5Medium">{remainingTime}</Typography>
              <Typography variant="paragraphMedium">{t('sec', { ns: i18nNS.GLOSSARY })}</Typography>
            </>
          }
        />
        <Typography color="success.400" variant="paragraphMedium">
          {t('marked_present', { ns: i18nNS.CLASS })}
        </Typography>
        <AttendanceProgressbar
          color="success"
          value={markedStudentPercentage}
          label={<Typography variant="h5Medium">{nowMarkedPresent}</Typography>}
        />
      </Stack>
      <StopAttendanceButton onClick={handleOnClickStopAttendance} color="error">
        {t('stop', { ns: i18nNS.GLOSSARY })}
      </StopAttendanceButton>
    </Stack>
  );
};

export default AttendanceInProgress;
